import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CloseModal } from '@Actions/modalActions';
export const ModalRoot = () => {
    const dispatch = useDispatch();
    const { ModalComponent, modalProps } = useSelector((state) => state.modal);
    if (!ModalComponent) {
        return null;
    }
    const closeModal = () => dispatch(new CloseModal());
    return _jsx(ModalComponent, Object.assign({}, modalProps, { closeModal: closeModal }));
};
